export const starProgramCase = {
    id: 'star-program',
    title: 'STAR Program Implementation',
    subtitle: 'Systematic Transformation Framework',
    category: 'Digital Transformation',
    description: 'Implemented systematic transformation framework delivering measurable outcomes across people, process, and technology.',
    status: 'warning',
    tags: ['Digital Transformation', 'Change Management', 'Process Improvement'],
    coverImage: '/cospin-logo.png',
    heroImage: '/cospin-logo.png',
    challenge: `A global enterprise needed to modernize its operations but struggled with siloed systems, inconsistent processes, and resistance to change. Previous transformation attempts had failed to deliver sustainable results.`,
    solution: `Cospin implemented the STAR (Systematic Transformation and Alignment Reform) Program:
  • Structured assessment of current state across all divisions
  • Technology stack modernization roadmap
  • Process reengineering with automation integration
  • Change management and training programs
  • Performance measurement framework`,
    results: [
        'Achieved 40% improvement in operational efficiency',
        'Reduced process cycle times by 65%',
        'Increased employee engagement scores by 35%',
        'Modernized 80% of legacy systems',
        'Established continuous improvement culture'
    ],
    metrics: {
        timeframe: '12 months',
        efficiencyGain: '40%',
        cycleTimeReduction: '65%',
        employeeEngagement: '+35%'
    },
    testimonial: {
        quote: "The STAR Program wasn't just another transformation initiative—it was a comprehensive change that stuck. The results speak for themselves.",
        author: "CEO, Global Technology Company"
    },
    filePath: '/case-studies/Cospin_CaseStudy_STARProgram.pdf'
};
